import Api from "../../lib/request";
import cookie from "../../lib/cookie";
import COOKIECONSTANT from "../../constant/cookie";
import qs from "querystring";
import { checkState, checkHttps,myToastErr } from "@roots/pLibrary/api/api.js";
const _url = COOKIECONSTANT.REQUEST_HOST
export const signDaMai = data => {
  return new Promise((resolve, reject) => {
    Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.user.auth.sign",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        checkState(data, resolve(data.data), reject(new Error("异常")));
      })
      .catch(e => {
        reject(e);
      });
  });
};
export const signDaMaiNew = data => {
  return new Promise((resolve, reject) => {
    Api.post(_url, JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.user.third.redirect-url",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        resolve(checkState(data) || false)
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};
//mall.show.order.detail
export const thirdOrderDmInfoNew = (data, that) => {
  return new Promise((resolve, reject) => {
    Api.get(`${_url}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.order.sp.detail",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        resolve(checkState(data) || false)
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};
export const thirdOrderDmInfo = (data, that) => {
  return new Promise((resolve, reject) => {
    Api.get(`${COOKIECONSTANT.REQUEST_HOST}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.show.order.detail",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        switch (data.status) {
          case 6808004:
            myToastErr(data,reject(data));
            break;
          case 6808003:
            myToastErr(data,reject(data));
            break;
          case 6808009:
            myToastErr(data,reject(data));
            break;
          default:
            checkState(data, resolve(data.data));
        }
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};
export const thirdOrderInfoNew = data => {
  return new Promise((resolve, reject) => {
    Api.get(`${_url}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.order.sp.third-detail",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        resolve(checkState(data) || false)
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};
export const thirdOrderInfo = data => {
  return new Promise((resolve, reject) => {
    Api.get(`${COOKIECONSTANT.REQUEST_HOST}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.show.order.third-detail",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        switch (data.status) {
          case 6808004:
            myToastErr(data,reject(data));
            break;
          case 6808003:
            myToastErr(data,reject(data));
            break;
          case 6808009:
            myToastErr(data,reject(data));
            break;
          default:
            checkState(data, resolve(data.data));
        }
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};

//mall.show.order.third-detail
